import { render, staticRenderFns } from "./404View.vue?vue&type=template&id=0d97f36e"
import script from "./404View.vue?vue&type=script&lang=js"
export * from "./404View.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports